
export default "/assets/stripe.9e7ceb1c.svg"